var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.documentloaded)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.document)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }